import {getCookie, setCookie} from "../Plugins/Cookies";
import PageLoadedQueue from "../PageLoadedQueue";

class ListSorting {
    constructor(selectElement: HTMLSelectElement, cookieName: string) {
        const currentValue = getCookie(cookieName);

        if (currentValue) {
            selectElement.value = currentValue;

            $(selectElement).selectpicker('val', currentValue);
        }

        selectElement.addEventListener('change', () => {
            setCookie(cookieName, selectElement.value);
            location.reload();
        }, {passive: false});
    }

    static initialize = () => {
        // orders sorting
        const ordersSortingSelect: HTMLSelectElement = document.querySelector('select.orders-sorting-select');
        if (ordersSortingSelect) {
            new ListSorting(ordersSortingSelect, 'avency-nwd-shop-orders-list-sort');
        }

        // invoice sorting
        const invoicesSortingSelect: HTMLSelectElement = document.querySelector('select.invoices-sorting-select');
        if (invoicesSortingSelect) {
            new ListSorting(invoicesSortingSelect, 'avency-nwd-shop-invoices-list-sort');
        }

        // packing slips sorting
        const packingSlipsSortingSelect: HTMLSelectElement = document.querySelector('select.packing-slips-sorting-select');
        if (packingSlipsSortingSelect) {
            new ListSorting(packingSlipsSortingSelect, 'avency-nwd-shop-packing-slips-list-sort');
        }

        // backorders sorting
        const backordersSortingSelect: HTMLSelectElement = document.querySelector('select.backorders-sorting-select');
        if (backordersSortingSelect) {
            new ListSorting(backordersSortingSelect, 'avency-nwd-shop-backorders-list-sort');
        }

        const sortToggles: NodeListOf<HTMLElement> = document.querySelectorAll('.sort-toggle');

        sortToggles.forEach((toggleElement:HTMLElement) => {
            //todo: own class?
            toggleElement.addEventListener('click', (e: Event) => {
                const [cookieName, targetSort] = toggleElement.dataset.sort.split(':');
                setCookie(cookieName, targetSort);
                location.reload();
            });
        });
    }
}

PageLoadedQueue.addFunction(ListSorting.initialize);
